import { render, staticRenderFns } from "./StaffSearch.vue?vue&type=template&id=1c418f15&scoped=true&"
import script from "./StaffSearch.vue?vue&type=script&lang=js&"
export * from "./StaffSearch.vue?vue&type=script&lang=js&"
import style0 from "./StaffSearch.vue?vue&type=style&index=0&id=1c418f15&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c418f15",
  null
  
)

export default component.exports